import { ValidatorResultType } from '.';

export class BaseRule {
	validationType: string;
	errorMessage: string;

	constructor(validationType: string, errorMessage: string) {
		this.validationType = validationType;
		this.errorMessage = errorMessage;
	}

	// ДАННАЯ ФУНКЦИЯ ДОЛЖНА ПЕРЕОПРЕДЕЛЯТЬСЯ В НАСЛЕДНИКАХ
	isValidInternal = (val: string): boolean => {
		throw new Error('ДАННАЯ ФУНКЦИЯ ДОЛЖНА ПЕРЕОПРЕДЕЛЯТЬСЯ В НАСЛЕДНИКАХ');
	};

	isValid = (val: string): ValidatorResultType => {
		const isValid = this.isValidInternal(val);
		return BaseRule.getValidationResult(
			isValid,
			!isValid ? this.errorMessage : '',
		);
	};

	static getValidationResult = (isValid: boolean, errorMessage = '') => {
		return {
			isValid,
			errorMessage,
		};
	};

	static isEmptyValue = (val: string) => {
		return val === undefined || val === null;
	};
}
